import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { profile } from '../data';
import profileImg from '../Assets/profile.png';

const roles = ['Backend Developer', 'NestJS & Node.js Dev', 'Full-Stack Developer', 'Freelancer'];

// Lightweight typewriter effect for the role line.
function useTypewriter(words, speed = 90, pause = 1400) {
  const [text, setText] = useState('');
  const [i, setI] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[i % words.length];
    let delay = deleting ? speed / 2 : speed;

    if (!deleting && text === current) {
      delay = pause;
      const t = setTimeout(() => setDeleting(true), delay);
      return () => clearTimeout(t);
    }
    if (deleting && text === '') {
      setDeleting(false);
      setI((v) => v + 1);
      return;
    }
    const t = setTimeout(() => {
      setText(current.substring(0, deleting ? text.length - 1 : text.length + 1));
    }, delay);
    return () => clearTimeout(t);
  }, [text, deleting, i, words, speed, pause]);

  return text;
}

function Hero() {
  const typed = useTypewriter(roles);
  const resumeUrl = require(`../Assets/${profile.resume}`);

  return (
    <header className="hero">
      <div className="hero-left reveal">
        <span className="hero-badge">
          <span className="dot"></span> Available for freelance &amp; full-time
        </span>
        <h1>
          Hi, I'm <span className="gradient-text">Purushothama G</span>
        </h1>
        <div className="hero-role">
          {typed}
          <span className="type-caret">|</span>
        </div>
        <p className="hero-tagline">{profile.tagline}</p>

        <div className="hero-cta">
          <Link to="/projects" className="btn btn-primary">
            View my work <i className="fa-solid fa-arrow-right"></i>
          </Link>
          <a href={resumeUrl} download className="btn btn-ghost">
            <i className="fa-solid fa-download"></i> Résumé
          </a>
        </div>

        <div className="hero-social">
          <a href={profile.socials.github} target="_blank" rel="noreferrer" aria-label="GitHub">
            <i className="fa-brands fa-github"></i>
          </a>
          <a href={profile.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a href={`mailto:${profile.email}`} aria-label="Email">
            <i className="fa-solid fa-envelope"></i>
          </a>
        </div>
      </div>

      <div className="hero-right reveal">
        <div className="avatar-wrap">
          <div className="avatar-ring"></div>
          <img className="avatar-img" src={profileImg} alt="Purushothama G" />
          <span className="avatar-chip c1">
            <i className="fa-brands fa-react"></i> React
          </span>
          <span className="avatar-chip c2">
            <i className="fa-brands fa-node-js"></i> Node.js
          </span>
          <span className="avatar-chip c3">
            <i className="fa-solid fa-cubes"></i> NestJS
          </span>
        </div>
      </div>
    </header>
  );
}

export default Hero;
